module.exports = __webpack_public_path__ + "static/img/banner_kunuocloud.9d1ce1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_kunuocloud.png
// module id = 9ao3
// module chunks = 71